<nz-modal
  [nzWidth]="'710px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Edit Customer Portrait'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="'Save'"
  (nzOnOk)="onSubmitClick()"
  [nzCancelText]="'Cancel'"
>
  <ng-container *nzModalContent>
    <nz-tabset>
      <nz-tab nzTitle="Choose from Library">
        <div class="tab-content">
          <app-portrait-select [(portraitUrl)]="portraitUrl"></app-portrait-select>
        </div>
      </nz-tab>
      <nz-tab nzTitle="Change Portrait Url">
        <div class="tab-content vertical">
          <div class="field-name">Portrait Url</div>
          <input nz-input [(ngModel)]="portraitUrl" />
        </div>
      </nz-tab>
    </nz-tabset>
  </ng-container>
</nz-modal>
